import { useSelector } from 'react-redux';

import { useFullscreenGalleryUserName } from './useFullscreenGalleryUserName';
import {
  currentOpenChatIDSelector,
  offerSelector,
  selectContentFullscreenSelectedImageUid,
  chatImagesSelector,
} from '../../../selectors';
import { getFileSrc } from '../../../utils/getFileSrc';

export const useFullscreenGalleryInfo = (): {
  src: string;
  userName: string;
  offerStr: string;
  created: number | null;
} => {
  const chatImages = useSelector(chatImagesSelector);
  const chatId = useSelector(currentOpenChatIDSelector);
  const offer = useSelector(offerSelector);
  const selectedImageUid = useSelector(selectContentFullscreenSelectedImageUid);

  const chatImagesFiles = chatImages?.files || [];

  const { userId, created } = chatImagesFiles.find(file => file.uid === selectedImageUid) || {};

  const userName = useFullscreenGalleryUserName(userId as number);
  const src = getFileSrc(selectedImageUid, chatId);

  return {
    src,
    userName,
    offerStr: offer?.formattedFullInfo || '',
    created: created ? created * 1000 : null,
  };
};
